'use client'

import React, { FC, ReactElement } from 'react'
import styles from './RankPill.module.css'
import classNames from 'classnames'

const RankPill: FC<{ className?: string; rank?: number }> = (props): ReactElement => {
	if (true || !props?.rank) {
		return <div />
	}

	return (
		<div
			className={classNames(
				{ [(props?.className as any)]: !!props?.className },
				styles.root,
				'text-xs',
				'semibold'
			)}
		>{`Rank #${props?.rank}`}</div>
	)
}

export default RankPill
